module.exports = __webpack_public_path__ + "img/dp-sy-lm22.af0829d6.png";